<div class="timer" [nbSpinner]="this.isLoading">
  <h4> Timer </h4>
  <!-- <span id="days"> {{daysToDday}} </span>Day(s) -->
  <span id="hours"> {{hoursToDday}} </span>Hrs 
  <span id="minutes"> {{minutesToDday}} </span>Min
  <span id="seconds"> {{secondsToDday}} </span>S
</div>
<div class="row">
  <div class="col-6 text-center">
    <button mat-raised-button type="button" (click)="this.startT()" [disabled]="this.isRunning">Start</button>
  </div>

  <div class="col-6 text-center">
    <button mat-raised-button type="button" (click)="this.pause()" [disabled]="!this.isRunning">Pause</button>
  </div>
</div>